import type {
  DexAlertResponse,
  DexAlertsFilter,
  DexAlertSortingKey,
  DexAlertsResponse,
} from '@/services/alerts-v2-service/types'
import { AlertsV2Service } from '@/services/alerts-v2-service'
import { createAlertsBase } from './factories/alertsFactory'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { FALLBACK_API_ERROR } from '@/utils/consts'
import type { FetchOptions } from '@/utils/types'

export const useDexCexAlertsStore = defineStore('dex-cex-alerts', () => {
  const alertsBase = createAlertsBase<
    DexAlertResponse,
    DexAlertsResponse,
    DexAlertsFilter,
    DexAlertSortingKey
  >({ sortBy: 'spread' }, AlertsV2Service.fetchDex)

  const wsEnabled = ref(false)

  const init = (isCexSpotValue: boolean) => {
    alertsBase.loading.value = true
    wsEnabled.value = false
    if (alertsBase.filters.value) {
      alertsBase.filters.value['is_cex_spot'] = isCexSpotValue
    }
  }

  const fetch = async (page: number, opts: FetchOptions = {}) => {
    alertsBase.page.value = page
    if (!opts.keepState) {
      alertsBase.loading.value = true
    }

    if (wsEnabled.value) {
      return
    }

    const filtersToSend = {
      ...alertsBase.filters.value,
    } as DexAlertsFilter

    try {
      const req = await AlertsV2Service.fetchDex(
        page,
        filtersToSend,
        alertsBase.sortBy.value as DexAlertSortingKey,
        alertsBase.sortOrder.value == -1 ? 'desc' : 'asc',
      )
      const data = req.data as DexAlertsResponse
      alertsBase.alerts.value = data.alerts
      alertsBase.pages.value = data.pages
      alertsBase.pageSize.value = data.page_size
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        alertsBase.error.value = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        alertsBase.error.value = FALLBACK_API_ERROR
      }
    } finally {
      alertsBase.loading.value = false
    }
  }

  const updateFromWs = (data: DexAlertsResponse) => {
    console.log(
      '[dexStore updateFromWs] called, alerts:',
      data?.alerts?.length,
      'pages:',
      data?.pages,
    )
    wsEnabled.value = true
    alertsBase.alerts.value = data.alerts
    alertsBase.pages.value = data.pages
    alertsBase.pageSize.value = data.page_size
    alertsBase.loading.value = false
    console.log('[dexStore updateFromWs] loading set to false')
  }

  return {
    ...alertsBase,
    init,
    fetch,
    updateFromWs,
    wsEnabled,
  }
})
